<template>
  <v-dialog v-model="show" persistent max-width="500px">
    <v-card>
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title class="text-subtitle-1"
          >Seleccione el tipo de turno</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon dark @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4 pb-2">
        <v-row>
          <v-col
            v-for="tipo in tiposTurno"
            :key="tipo.idTipoTurno"
            cols="12"
            sm="6"
          >
            <v-card
              outlined
              hover
              class="tipo-turno-card pa-3 text-center"
              @click="seleccionar(tipo)"
              :ripple="true"
            >
              <v-icon color="primary" large class="mb-2"
                >mdi-calendar-check</v-icon
              >
              <div class="text-subtitle-1 font-weight-medium">
                {{ tipo.nombreTipoTurno }}
              </div>
              <div class="text-caption grey--text text--darken-1 sigla-slot">
                {{ tipo.sigla || "&nbsp;" }}
              </div>
              <v-chip
                v-if="tipo.precioConsultaString"
                color="red"
                outlined
                small
                label
                class="mt-2 font-weight-bold"
              >
                <v-icon left x-small>mdi-currency-usd</v-icon>
                {{ tipo.precioConsultaString }}
              </v-chip>
              <div v-else class="mt-2 precio-placeholder">&nbsp;</div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalTipoTurno",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tiposTurno: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    seleccionar(tipo) {
      this.$emit("tipoTurnoSeleccionado", tipo);
    },
    cerrar() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.tipo-turno-card {
  cursor: pointer;
  transition: all 0.2s;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.tipo-turno-card:hover {
  border-color: #1976d2 !important;
  background-color: #e3f2fd;
}
.sigla-slot {
  min-height: 18px;
}
.precio-placeholder {
  min-height: 24px;
}
</style>
